
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"colorList.ariaLabel":"Farbpalette","customColorControl.label":"Benutzerdefinierte Farbe ...","opacityControl.label":"Deckkraft"},"en":{"colorList.ariaLabel":"Color palette","customColorControl.label":"Custom color ...","opacityControl.label":"Opacity"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();